import React from 'react';
import {Col, Row} from "react-bootstrap";

export default function Navbar({content}) {
    return <Row className='sticky-nav'>
        <Col className='col-left'>
            <Row>{content[0]}</Row>
            <Row>{content[1]}</Row>
        </Col>
        <Col  className='col-center'>
            <Row>{content[2]}</Row>
            <Row>{content[3]}</Row>
        </Col>
        <Col  className='col-right'>
            <Row>{content[4]}</Row>
            <Row>{content[5]}</Row>
        </Col>
    </Row>;
}
